// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2kK1l","addWidgetButton":"Header_addWidgetButton__pZ2AH","dashboardTabs":"Header_dashboardTabs__2qSu1","active":"Header_active__3hUGA"};